<template>
  <section class="featureList" :id="content.name">
    <h2 v-if="content.headline">{{content.headline}}</h2>
    <ul class="list">
      <li v-for="(element, n) in content.data" :key="n">{{element.text}}</li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'FeatureList',
  props: {
    content: {
      type: Object,
      default() {
        return {
          headline: String,
          image: Object,
          text: String
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>


</style>
